var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from "react";
import { IdenticonsCustomProperty, useColorMap } from "../common";
export var IdenticonBranding = function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(" + IdenticonsCustomProperty.light + ", " + colorMap.light + ")",
        base: "var(" + IdenticonsCustomProperty.base + ", " + colorMap.base + ")",
        dark: "var(" + IdenticonsCustomProperty.dark + ", " + colorMap.dark + ")",
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M24.169 28.532a20.12 20.12 0 011.795 2.203C40.9 15.954 44.114 7.17 43.918 5.329a1.414 1.414 0 00-.409-.852l-.118-.115-.007-.007c-.308-.302-.851-.389-1.277-.344-2.033.212-10.103 4.574-22.802 20.787 3.085 1.676 4.864 3.734 4.864 3.734z", fill: fills.dark }),
        React.createElement("path", { d: "M21.072 29.462s-2.891-3.043-6.907-1.727C10.15 29.05 9.055 35.99 7.7 38.513c-1.355 2.52-2.964 3.101-3.562 3.597-.65.544 1.005 1.737 4.339 1.873 4.18.172 10.731-.957 13.677-4.32 2.38-2.717 1.665-7.557-1.083-10.201z", fill: fills.light })));
};
